import { Target, Globe2, ExternalLink, MapPin } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-16" data-testid="about-page">
      <div className="max-w-3xl mb-14">
        <p className="text-sm font-bold text-[#D52B1E] uppercase tracking-widest mb-3">About</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]">
          Learning Without <span className="gradient-maple-text">Borders</span>
        </h1>
      </div>

      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-6 text-slate-600 leading-relaxed">
          <p>
            StudyTrip Global is an international education initiative developed and operated by <span className="font-semibold text-slate-900">TeachMeOnline Inc.</span>, a Canadian company committed to creating innovative learning experiences through its education platform,{" "}
            <a
              href="https://teacher4me.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 font-semibold text-[#D52B1E] hover:text-[#A31E13]"
              data-testid="about-teacher4me-link"
            >
              teacher4me.ca <ExternalLink className="w-3.5 h-3.5" />
            </a>
            . Our mission is to connect students with global learning opportunities, cultural exchange, and professional development programs across multiple countries.
          </p>
          <p>
            StudyTrip Global creates short-term international learning experiences that combine education, travel, culture, professional development, and global exposure. Our goal is to help students become more confident, informed, adaptable, and internationally aware.
          </p>
          <p>
            We work with educational institutions, training organizations, businesses, and international partners to create meaningful programs that go beyond traditional classroom learning.
          </p>

          <div className="mt-8 rounded-3xl bg-[#FAF6EE] border border-amber-100 p-6" data-testid="about-company-card">
            <p className="text-xs font-bold text-amber-800 uppercase tracking-widest mb-2">Operated by</p>
            <p className="font-display text-2xl font-extrabold text-slate-900">Teach Me Online Inc.</p>
            <p className="text-sm text-slate-600 mt-1 inline-flex items-center gap-1.5">
              <MapPin className="w-3.5 h-3.5 text-[#D52B1E]" /> Canada
            </p>
            <p className="text-sm text-slate-600 mt-3">
              Learn more about our education platform:{" "}
              <a
                href="https://teacher4me.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#D52B1E] hover:text-[#A31E13]"
              >
                teacher4me.ca
              </a>
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="rounded-3xl bg-[#FFE9E6] border border-red-100 p-6" data-testid="about-mission">
            <div className="w-10 h-10 rounded-xl bg-[#D52B1E] text-white grid place-items-center mb-3">
              <Target className="w-5 h-5" />
            </div>
            <h3 className="font-display font-extrabold text-slate-900 mb-1">Our Mission</h3>
            <p className="text-sm text-slate-700 leading-relaxed">
              To make international education and global exposure more accessible, practical, inspiring, and affordable for students around the world.
            </p>
          </div>

          <div className="rounded-3xl bg-[#E4F1EE] border border-emerald-100 p-6" data-testid="about-vision">
            <div className="w-10 h-10 rounded-xl bg-[#1F4A3A] text-white grid place-items-center mb-3">
              <Globe2 className="w-5 h-5" />
            </div>
            <h3 className="font-display font-extrabold text-slate-900 mb-1">Our Vision</h3>
            <p className="text-sm text-slate-700 leading-relaxed">
              To build a global network where students can learn, travel, connect, and grow across multiple countries.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
